(function () {
  'use strict';

  var script = document.currentScript;
  var mapUrl = script && script.getAttribute('data-review-map');
  var selector = '[data-lux-review-skus]';
  var mapPromise = null;

  if (!mapUrl) return;

  function loadMap() {
    if (mapPromise) return mapPromise;

    mapPromise = new Promise(function (resolve) {
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 8000);

      fetch(mapUrl, {
        cache: 'force-cache',
        credentials: 'same-origin',
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Review map unavailable');
          return response.json();
        })
        .then(function (data) { resolve(data && typeof data === 'object' ? data : {}); })
        .catch(function () { resolve({}); })
        .finally(function () { window.clearTimeout(timeout); });
    });

    return mapPromise;
  }

  function summaryFor(card, reviewMap) {
    var seen = {};
    var total = 0;
    var weighted = 0;
    var skus = (card.getAttribute('data-lux-review-skus') || '').split('|');

    skus.forEach(function (rawSku) {
      var sku = rawSku.trim().toUpperCase();
      if (!sku || seen[sku]) return;
      seen[sku] = true;
      var entry = reviewMap[sku];
      if (!Array.isArray(entry)) return;
      var rating = Number(entry[0]);
      var count = Number(entry[1]);
      if (!Number.isFinite(rating) || !Number.isFinite(count) || rating <= 0 || count <= 0) return;
      weighted += rating * count;
      total += count;
    });

    return total ? { rating: weighted / total, count: total } : null;
  }

  function render(card, reviewMap) {
    if (!card || card.getAttribute('data-lux-review-ready') === 'true') return;
    var badge = card.querySelector('[data-lux-review-summary]');
    if (!badge) return;

    var summary = summaryFor(card, reviewMap);
    card.setAttribute('data-lux-review-ready', 'true');
    if (!summary) return;

    var ratingText = summary.rating.toFixed(1);
    var value = badge.querySelector('[data-lux-review-value]');
    var count = badge.querySelector('[data-lux-review-count]');
    if (value) value.textContent = ratingText;
    if (count) count.textContent = '(' + summary.count + ')';
    badge.setAttribute(
      'aria-label',
      ratingText + ' out of 5 from ' + summary.count + ' verified pre-owned ' + (summary.count === 1 ? 'purchase' : 'purchases')
    );
    badge.hidden = false;
  }

  function cardsWithin(root) {
    var cards = [];
    if (root && root.nodeType === 1 && root.matches(selector)) cards.push(root);
    if (root && root.querySelectorAll) {
      cards = cards.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }
    return cards;
  }

  function hydrate(root) {
    var cards = cardsWithin(root || document);
    if (!cards.length) return;
    loadMap().then(function (reviewMap) {
      cards.forEach(function (card) { render(card, reviewMap); });
    });
  }

  function start() {
    hydrate(document);
    document.addEventListener('shopify:section:load', function (event) { hydrate(event.target); });

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType === 1) hydrate(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
